import { __ } from '@wordpress/i18n'
import { useContext, useState } from 'react';
import SbUtils from '../../../../Utils/SbUtils';
import Button from '../../../Common/Button';
import Input from '../../../Common/Input';
import SettingsScreenContext from '../../../Context/SettingsScreenContext';

const ManageLicenseKey = (props) => {
    const {
        sbCustomizer,
        editorNotification,
        editorTopLoader,
        proLicenseMemo
    } = useContext(SettingsScreenContext);

    const [licenseStatus, setLicenseStatus] = useState(SbUtils.checkNotEmpty(sbCustomizer?.pluginSettings?.license_status)
        ? sbCustomizer?.pluginSettings?.license_status
        : null
    );

    const [licenseKey, setLicenseKey] = useState(sbCustomizer?.pluginSettings?.license_key || '');

    const [testConnectionLoad, setTestConnectionLoad] = useState(false);

    const [recheckLicenseLoad, setRecheckLicenseLoad] = useState(false);

    const licenseKeyAction = () => {
        const notificationsContent = {
            success: {}
        },
            successNotification = {
                type: 'success',
                icon: 'success',
                text: __('License Activated!', 'sb-customizer'),
                time: 10000
            },
            invalidNotification = {
                type: 'error',
                icon: 'notice',
                text: __('Invalid License!', 'sb-customizer'),
                time: 60000
            },
            deactivatedNotification = {
                type: 'success',
                icon: 'success',
                text: __('License Deactivated!', 'sb-customizer'),
                time: 10000
            },
            limitExceededNotification = {
                type: 'error',
                icon: 'notice',
                text: __('License limit exceeded. No activations left!', 'sb-customizer'),
                time: 60000
            },
            expiredNotification = {
                type: 'error',
                icon: 'notice',
                text: __('License Expired!', 'sb-customizer'),
                time: 60000
            };

        const formData = {
            action: licenseStatus !== 'valid' ? 'sbtt_activate_license' : 'sbtt_deactivate_license',
            license_key: licenseKey
        }
        SbUtils.ajaxPost(
            sbCustomizer.ajaxHandler,
            formData,
            (data) => { //Call Back Function
                switch (data?.data?.license) {
                    case 'valid':
                        notificationsContent.success = successNotification;
                        break;
                    case 'deactivated':
                        notificationsContent.success = deactivatedNotification;
                        break;
                    case 'invalid':
                        notificationsContent.success = invalidNotification;
                        break;
                    case 'limit_exceeded':
                        notificationsContent.success = limitExceededNotification;
                        break;
                    case 'expired':
                        notificationsContent.success = expiredNotification;
                        break;
                    default:
                        break;
                }
                setLicenseStatus(data?.data?.license);
            },
            editorTopLoader,
            editorNotification,
            notificationsContent
        )
    }


    const testConnection = () => {
        setTestConnectionLoad(true)
        const formData = {
            action: 'sbtt_test_connection',
            license_key: licenseKey
        }
        SbUtils.ajaxPost(
            sbCustomizer.ajaxHandler,
            formData,
            (data) => { //Call Back Function
                setTestConnectionLoad(data?.success ? 'success' : 'error')
                setTimeout(() => {
                    setTestConnectionLoad(false)
                }, 4000);
            },
            editorTopLoader,
            null,
            null
        )
    }

    const recheckLicense = () => {
        setRecheckLicenseLoad(true)
        const formData = {
            action: 'sbtt_recheck_license',
            license_key: licenseKey
        }
        SbUtils.ajaxPost(
            sbCustomizer.ajaxHandler,
            formData,
            (data) => { //Call Back Function
                setRecheckLicenseLoad(data?.success ? 'success' : 'error')
                if (
                    data?.isLicenseUpgraded !== undefined &&
                    data?.isLicenseUpgraded !== false
                ) {
                    proLicenseMemo.setLicenseUpgradeData({
                        ...proLicenseMemo.licenseUpgradeData,
                        isLicenseUpgraded: true,
                        licenseUpgradedInfo: data.licenseUpgradedInfo
                    });
                }
                setTimeout(() => {
                    setRecheckLicenseLoad(false)
                }, 4000);
            },
            editorTopLoader,
            null,
            null
        )
    }
    return (
        <>
            <span className='sb-text-small sb-dark-text'>
                {
                    licenseStatus === null &&
                    <>
                        {__('Please add your ', 'sb-customizer')}
                        <strong>TikTok Feeds Pro </strong>
                        {__('License Key ', 'sb-customizer')}
                    </>
                }
                {
                    licenseStatus !== null &&
                    <>
                        {__('Your ', 'sb-customizer')}
                        <strong>TikTok Feeds Pro</strong>{__(' License is ', 'sb-customizer')}
                        {(licenseStatus === 'valid' && __('Active', 'sb-customizer'))
                            || (licenseStatus === 'invalid' && __('Inactive', 'sb-customizer'))
                            || (licenseStatus === 'expired' && __('Expired', 'sb-customizer'))
                            || __('Inactive', 'sb-customizer')}!
                    </>
                }
            </span>
            <div className='sb-settings-input-ctn'>
                <div>
                    <Input
                        size='medium'
                        customClass={`${'sb-license-key-' + licenseStatus}`}
                        type='password'
                        value={licenseKey}
                        onChange={(event) => {
                            setLicenseKey(event.currentTarget.value)
                        }}
                        trailingIcon={licenseStatus === 'valid' ? 'success' : 'notice'}
                    />
                    <div className='sb-licensekey-actions sb-fs'>
                        <div className='sb-licensekey-actions-left'>
                            <a
                                className='sb-text-tiny sb-licensekey-manage-btn'
                                href={'https://smashballoon.com/account/?tiktok&utm_campaign=tiktok-pro&utm_source=settings&utm_medium=license&utm_content=Manage'}
                                target='_blank'
                                rel='noreferrer'
                            >
                                {__('Manage License', 'sb-customizer')}
                            </a>
                        </div>
                        <div className='sb-licensekey-actions-right'>
                            <span
                                className='sb-text-tiny sb-licensekey-test-btn'
                                onClick={() => {
                                    if (testConnectionLoad === false) {
                                        testConnection()
                                    }
                                }}
                            >
                                {
                                    (testConnectionLoad === true || testConnectionLoad === 'success' || testConnectionLoad === 'error') &&
                                    <span className='sb-licensekey-test-icon' data-icon={testConnectionLoad}></span>
                                }

                                {testConnectionLoad === false && __('Test Connection', 'sb-customizer')}
                                {testConnectionLoad === 'success' && __('Connection successful', 'sb-customizer')}
                                {testConnectionLoad === 'error' && __('Connection Error', 'sb-customizer')}
                            </span>

                            {
                                SbUtils.checkNotEmpty(licenseKey) &&
                                <span
                                    className='sb-text-tiny sb-licensekey-test-btn'
                                    onClick={() => {
                                        if (recheckLicenseLoad === false) {
                                            recheckLicense()
                                        }
                                    }}
                                >
                                    {
                                        (recheckLicenseLoad === true || recheckLicenseLoad === 'success' || recheckLicenseLoad === 'error') &&
                                        <span className='sb-licensekey-test-icon' data-icon={recheckLicenseLoad}></span>
                                    }
                                    {recheckLicenseLoad === false && __('Recheck License', 'sb-customizer')}
                                    {recheckLicenseLoad === 'success' && __('Connection successful', 'sb-customizer')}
                                    {recheckLicenseLoad === 'error' && __('Connection Error', 'sb-customizer')}
                                </span>
                            }
                            <a
                                className='sb-text-tiny sb-licensekey-upgrade-btn'
                                href={sbCustomizer?.upgradeProLink}
                                target='_blank'
                                rel='noreferrer'
                            >
                                {__('Upgrade', 'sb-customizer')}
                            </a>
                        </div>
                    </div>
                </div>
                <Button
                    text={licenseStatus !== 'valid' ? __('Activate', 'sb-customizer') : __('Deactivate', 'sb-customizer')}
                    type='secondary'
                    size='medium'
                    onClick={() => {
                        licenseKeyAction()
                    }}
                />
            </div>
        </>

    );
}

export default ManageLicenseKey;